import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'

/**
 * Returns a stable callback that invalidates React Query cache for the given key prefix.
 *
 * Use this in child components (Actions, Popconfirm) that need to trigger a re-fetch
 * without receiving `refetch` as a prop or reading it from the Zustand store.
 *
 * Usage:
 * ```ts
 * const refetch = useEntityInvalidate('/v1/materials/pageable/list')
 * <Popconfirm refetch={refetch} url={deleteUrl} />
 * ```
 */
export function useEntityInvalidate(queryKeyPrefix: string | string[]) {
  const queryClient = useQueryClient()

  return useCallback(() => {
    const key = Array.isArray(queryKeyPrefix) ? queryKeyPrefix : [queryKeyPrefix]
    queryClient.invalidateQueries({ queryKey: key })
  }, [queryClient, queryKeyPrefix])
}
